import {ErrorResponse} from '@gtpl/shared-models/common-models';
import { AllPalletsResponseModel, CommonResponse, CreatePalletsResponseModel, PalletAckResponse, PalletDto, PalletModel, PalletResponse, PalletsResponseModel } from '@gtpl/shared-models/masters';
import { FactoriesInput } from '@gtpl/shared-models/sale-management';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Controller, Injectable } from '@nestjs/common';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { UnitCodesService } from '../unit-codes/unit-codes.service';
import { PalletUpdateDTO } from './dto/pallet-update.dto';
import { PalletDTO } from './dto/pallet.dto';
import { PalletRequest } from './dto/pallet.request';
import { PalletsAdapter } from './dto/pallets.adapter';
import { PalletsDTO } from './dto/pallets.dto';
import { PalletsDtoActive } from './dto/pallet_dto_active';
import { PlantPalletRequest } from './dto/plant-pallet.request';
import { Pallet } from './pallets.entity';
import { PalletsRepository } from './pallets.repository';

@Injectable()
export class PalletsService {
    constructor(
      private logService:LogsService,

        private repository: PalletsRepository, private adapter: PalletsAdapter,
        private UnitCodesRepo: UnitcodeService,
        ) {

    }
    
    async CreatePallets(details: PalletsDTO, isUpdate: boolean): Promise<CreatePalletsResponseModel> {
        console.log(details);
        //this section will be executed while creating a new user only
        if (!isUpdate) {
            const palletEntity = await this.getPallet(details.palletNo);
            if (palletEntity) {
                
  
                throw new CreatePalletsResponseModel(false,11104, 'Pallet  already exists');
            }
        }else{
            const palletEntity = await this.getPallet(details.palletNo);
            console.log(palletEntity);
            if (palletEntity) {
                if(palletEntity.palletId!=details.palletId){
                    throw new CreatePalletsResponseModel(false,11104, 'Pallet  already exists');
                }
            }
        }
        const convertedEntity = await this.adapter.convertDtoToEntity(details);
        const response = await this.repository.save(convertedEntity);
        if (response) {
            const data = new PalletDto(response.palletNo, response.palletNo,response.createdUser, response.isActive, response.updatedUser);
            const respp= new CreatePalletsResponseModel(true, 2234, 'Pallet Details Created Successfully',data )
            const newLogDto = new LogsDto(1,'Created', 'Pallet', response.palletId, true, '',response.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return respp
        } else {
            throw new CreatePalletsResponseModel(false,9999, 'Failed To Create');
        }
    }

    async getRecordByPalletsId(id: number): Promise<PalletsResponseModel> {
        const responseData = await this.repository.findOne({ where: { palletId: id } });

        if (responseData) {
            const data = new PalletDto(responseData.palletNo,responseData.palletNo ,responseData.createdUser, responseData.isActive, responseData.updatedUser);
            return new PalletsResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new CreatePalletsResponseModel(false,9999, 'No Data Found');
        }
    }

    async getPallet( palletNo: string): Promise<Pallet> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { palletNo: palletNo },
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;


        }
    }
    async getPalletData(palletId: number): Promise<Pallet> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { palletId: palletId },
        });
        console.log(response);
        if (response) {
            return response;
        } else {
            return null;


        }
    }
    async getPalletById(palletRequest: PalletRequest): Promise<PalletsResponseModel> {
        console.log(palletRequest)
        try{
            const palletData = await this.repository.findOne({
             where: { palletId: palletRequest.palletId },
            });
            const palletDto = new PalletDto(palletData.palletNo,palletData.palletNo,palletData.createdUser,palletData.isActive,palletData.updatedUser,palletData.palletId,palletData.versionFlag)
            console.log(palletDto);
            const response = new PalletsResponseModel(true,1101,"Pallet retrived successfully",palletDto)
            return response;
        } catch (err) {
            throw err;
        }
    }
    async activateorDeactivatePallet(palletAct: PalletsDtoActive): Promise<PalletResponse> {
        try {
            console.log('palletAct', palletAct);
            const palletExists = await this.getPalletData(palletAct.palletId);
            console.log(palletExists.versionFlag);
            if (palletExists) {
                if (palletAct.versionFlag !== palletExists.versionFlag) {
                    throw new CreatePalletsResponseModel(false,10113, 'Someone updated the current pallets information.Refresh and try again');
                } else {

                    const palletSatatus = await this.repository.update(
                        { palletId: palletAct.palletId },
                        { isActive: palletAct.isActive, updatedUser: palletAct.updatedUser });
                    const updatedRecord = await this.getRecordByPalletsId(palletAct.palletId);
                    if (palletExists.isActive) {
                        if (palletSatatus.affected) {
                            const palletResponse: PalletResponse = new PalletResponse(true, 10115, 'Pallet is de-activated successfully');
                            return palletResponse;
                        } else {
                            throw new CreatePalletsResponseModel(false,10111, 'Pallet is already deactivated');
                        }
                    } else {
                        if (palletSatatus.affected) {
                            const palletcatResponse: PalletResponse = new PalletResponse(true, 10114, 'Pallet is activated successfully', updatedRecord.data);
                            return palletcatResponse;
                        } else {
                            throw new CreatePalletsResponseModel(false,10112, 'pallet is already  activated');
                        }
                    }
                }
            } else {
                throw new CreatePalletsResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }


    // New services as per navtech requirement. Wooden configuration service

    /**
     * Service to create new pallet
     * @param palletDto 
     * @returns 
     */
    async createPallet(palletDto: PalletDTO): Promise<CommonResponse> {
        const palletCount = await this.repository.count({
            where: { plantId: palletDto.plantId },
        });
        console.log(palletCount)

        const unitCode = await this.UnitCodesRepo.getPlantDetailsById({unitcodeId:palletDto.plantId});
        if(!unitCode){
            throw new CreatePalletsResponseModel(false,10000, 'Plant short code not found');
        }
        const palletNo = (palletCount.toString().length > 3) ? palletCount+1 : ('0000' + (palletCount+1)).slice(-4);
        console.log(palletCount.toString().length)
        console.log(palletNo)
        console.log(palletCount)
        const palletEntity = new Pallet();
        palletEntity.palletNo = unitCode.status?unitCode.data.plantCode+palletNo:""+palletNo;
        palletEntity.palletCode = "";
        palletEntity.assocRfId = palletDto.assocRfId;
        palletEntity.plantId = palletDto.plantId;
        palletEntity.createdUser = palletDto.createdUser;
        if(palletDto.occupancy) {
            palletEntity.occupancy = palletDto.occupancy;
        }
        const palletResponse = await this.repository.save(palletEntity);            
        if (palletResponse) {
            const respp= new CommonResponse(true, 10000, 'Pallet Details Created Successfully',palletResponse.palletNo);
            const newLogDto = new LogsDto(1,'Pallet Created', 'Pallet', palletResponse.palletId, true, '',palletResponse.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return respp
        }
    }

    /**
     * validate if a pallet is existed or not
     * @param palletNo 
     * @returns boolean true/false
     */
    async validatePalletExistsOrNot(palletNo: number): Promise<boolean> {
        const palletResponse = await this.repository.findOne({
            where: { palletNo: palletNo },
        });
        if(palletResponse) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Service to update a pallet details
     * @param palletDto 
     * @returns 
     */
    async updatePallet(palletDto: PalletUpdateDTO): Promise<CommonResponse> {
        const palletEntity = await this.repository.findOne({
            where: { palletNo: palletDto.palletNo },
        });
        if(!palletEntity) {
            throw new CreatePalletsResponseModel(false,10000, 'Pallet details not found');
        } else {
            palletEntity.palletNo = palletDto.palletNo;
            palletEntity.assocRfId = palletDto.assocRfId;
            palletEntity.plantId = palletDto.plantId;
            palletEntity.updatedUser = palletDto.updatedUser;
            if(palletDto.occupancy) {
                palletEntity.occupancy = palletDto.occupancy;
            }
            const palletResponse = await this.repository.save(palletEntity);            
            if (palletResponse) {
                const repp = new CommonResponse(true, 10000, 'Pallet Details Updated Successfully',palletResponse.palletNo);
                const newLogDto = new LogsDto(1,'Pallet Updated', 'Pallet', palletResponse.palletId, true, '',palletResponse.createdUser)
            let res = await this.logService.createLog(newLogDto);
                return repp
            }
        }
    }

    /**
     * Service to get all the pallets
     * @returns 
     */
    async getAllPallets(req:PlantIdRequest): Promise<PalletAckResponse> {
        const palletsResponse = await this.repository.find({
            where:{plantId:req.plantId},
            order:{palletId: "ASC"},
        });
        const getAllPlants =  await this.UnitCodesRepo.getAllPlants();

        const palletDetails: PalletModel[] = [];
        if (palletsResponse.length === 0) {
            throw new CreatePalletsResponseModel(false,9999, 'Pallets details not found');
        }
        for(const pallet of palletsResponse) {
            const getPlantDetails = getAllPlants.status?getAllPlants.data.filter(rec => rec.plantId===pallet.plantId)[0].plantName:"";
            console.log(getPlantDetails);
            const palletModel = new PalletModel(pallet.palletId,pallet.palletNo,pallet.plantId,getPlantDetails,pallet.assocRfId,pallet.occupancy,pallet.createdAt,pallet.updatedAt,pallet.isActive,pallet.versionFlag);
            palletDetails.push(palletModel);
        }
        const respp = new PalletAckResponse(true, 10000, 'Pallet Details Retrived Successfully', palletDetails);
        const newLogDto = new LogsDto(1,'view', 'Pallet', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
        return respp
    }

    /**
     * Service to get all the pallets by plant id
     * @param plantIdReq
     * @returns 
     */
     async getPalletsByPlantId(plantIdReq: PlantIdRequest): Promise<PalletAckResponse> {
        const palletsResponse = await this.repository.find({
            where: {plantId: plantIdReq.plantId},
            order:{palletId: "ASC"},
        });

        const palletDetails: PalletModel[] = [];
        if (palletsResponse.length === 0) {
            throw new CreatePalletsResponseModel(false,9999, 'Pallets details not found');
        }
        for(const pallet of palletsResponse) {
            const getPlantDetails =  await this.UnitCodesRepo.getPlantDetailsById({unitcodeId:pallet.plantId});
            const palletModel = new PalletModel(pallet.palletId,pallet.palletNo,pallet.plantId,getPlantDetails.status?getPlantDetails.data.unitcodeName:"",pallet.assocRfId,pallet.occupancy,pallet.createdAt,pallet.updatedAt,pallet.isActive,pallet.versionFlag);
            palletDetails.push(palletModel);
        }
        return new PalletAckResponse(true, 10000, 'Pallet Details Retrived Successfully', palletDetails);
    }

    

    /**
     * validate if a pallet is existed or not
     * @param palletNo 
     * @returns boolean true/false
     */
     async isPalletRegistered(plantPalletIdReq: PlantPalletRequest): Promise<PalletAckResponse> {
        const palletResponse = await this.repository.findOne({
            where: { plantId: plantPalletIdReq.plantId,palletNo:plantPalletIdReq.palletId },
        });
        if(!palletResponse) {
            throw new CreatePalletsResponseModel(false,10000,'Pallet is not registered');
        } else {
            return new PalletAckResponse(true,10000,'Pallet is registered');
        }
    }

    /**
     * validate if a pallet is existed or not
     * @param palletNo 
     * @returns boolean true/false
     */
     async getEpcForPallet(plantPalletIdReq: PlantPalletRequest): Promise<CommonResponse> {
        const palletResponse = await this.repository.findOne({
            select:["assocRfId"],
            where: { plantId: plantPalletIdReq.plantId,palletNo:plantPalletIdReq.palletId },
        });
        if(!palletResponse) {
            throw new CreatePalletsResponseModel(false,10000,'Pallet details not found');
        } else {
            return new CommonResponse(true,10000,'Pallet details found',palletResponse.assocRfId);
        }
    }

    async getPalletByPalletNo(palletRequest: PlantPalletRequest): Promise<CommonResponse> {
        console.log(palletRequest)
        try{
            const palletData = await this.repository.findOne({
             where: { palletNo: palletRequest.palletId, plantId: palletRequest.plantId },
            });
            if(palletData.palletId!=undefined){
                const response = new CommonResponse(true,1101,"Pallet retrived successfully",palletData)
                return response;
            }
            else{
                const response = new CommonResponse(false,1101,"No Pallet Found")
                return response;
            }
        } catch (err) {
            throw err;
        }
    }

}
